import React, { useEffect, useState } from "react";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import DateConverter from "@heartinz/date_and_time_processor";
import { CheckIcon, CircleIcon, NotepadIcon, XIcon } from "../../../constants/Icons";

const AddSaleProductProforma = ({ data, onClose, onAdd }) => {
  // console.log(data);
  const [selectedItems, setSelectedItems] = useState([]);
  useEffect(() => {
    if (data?.saleitems) {
      setSelectedItems(data.saleitems.map((_, i) => i));
    }
  }, [data]);
  return (
    <div className="modal-overlay" style={{ zIndex: 1010 }}>
      <div className="modal-backdrop show"></div>
      <div
        className="modal show"
        id="JObCardModal"
        tabIndex="-1"
        aria-modal="true"
        role="dialog"
        style={{ display: "block" }}
      >
        <div className="modal-dialog modal-xl modal-dialog-scrollable modal-dialog-centered ">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title me-2">Select sale Product</h5>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
              ></button>
            </div>
            <div className="modal-body bg-blue ">
              <div className="row mb-3">
                <div className="col-md-4">
                  <strong>Sale No :</strong>
                  <span className="badge bg-label-primary ms-2">
                    {data?.saleno}
                  </span>
                </div>

                <div className="col-md-4">
                  <strong>Sale Date :</strong>{" "}
                  {DateConverter.ISOToDisplayFormat(data?.saledate).date}
                </div>

                <div className="col-md-4">
                  <strong>Sale Mode :</strong>
                  <span className="badge bg-label-success ms-2">
                    {data?.salemode}
                  </span>
                </div>
              </div>
              <table className="table table-bordered align-middle mb-0">
                <thead
                  className="table-light"
                  style={{
                    position: "sticky",
                    top: 0,
                    zIndex: 8,
                  }}
                >
                  <tr>
                    <th className="text-center">
                      <input
                        type="checkbox"
                        checked={
                          selectedItems.length === data?.saleitems?.length
                        }
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelectedItems(data.saleitems.map((_, i) => i));
                          } else {
                            setSelectedItems([]);
                          }
                        }}
                      />
                    </th>
                    <th className="w-30">Description</th>
                    <th className="text-center">MRP</th>
                    <th className="text-center">Discount</th>
                    <th className="text-center">Sale Price</th>
                    <th className="text-center">Qty</th>
                    <th className="text-center">Total</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.saleitems?.map((item, index) => (
                    <tr
                      key={item.imode + index}
                      className="position-relative  cursor-poInter hover-row"
                      data-item={JSON.stringify(item)}
                    >
                      <td className="text-center">
                        <div className="d-flex align-items-center justify-content-center gap-2">
                          <input
                            type="checkbox"
                            checked={selectedItems.includes(index)}
                            onChange={(e) => {
                              if (e.target.checked) {
                                setSelectedItems((prev) => [...prev, index]);
                              } else {
                                setSelectedItems((prev) =>
                                  prev.filter((i) => i !== index),
                                );
                              }
                            }}
                          />

                          <span>{index + 1}</span>

                          {item.imode === "SERVICE" && (
                            <span className="rounded fsz-10 ms-1">
                              <CircleIcon iClass={"text-yellow"}/>
                            </span>
                          )}
                          {item.imode === "RECHARGE" && (
                            <span className="rounded fsz-10 ms-1">
                              <CircleIcon iClass={"text-yellow"}/>
                            </span>
                          )}
                          {item.imode === "PRODUCT" && (
                            <span className="rounded fsz-10 ms-1">
                              <CircleIcon iClass={"text-primary"}/>
                            </span>
                          )}
                        </div>
                      </td>
                      <td className="text-wrap" width="280">
                        <div className="d-flex justify-content-between align-items-start">
                          <div className="me-2">
                            {item.title} - &nbsp;
                            <small className="badge rounded-pill bg-label-peace">
                              {item.taxpercentage}%
                            </small>
                            {item.imode === "SERVICE" && (
                              <div className="ms-0 fs-12 text-truncate-description">
                                {item.description}
                              </div>
                            )}
                            {item.imode === "PRODUCT" && (
                              <div className="ms-0 fs-12 text-truncate-description text-muted d-flex align-items-start">
                                <button
                                  type="button"
                                  className="me-2 rounded btn-label-primary shadow-none border-0"
                                >
                                  <NotepadIcon/>
                                </button>
                                {item.note && <span>{item.note}</span>}
                              </div>
                            )}
                          </div>
                        </div>
                      </td>
                      <td className="text-center">
                        ₹{CurrencyConverter.toCurrency(item.mrp || 0, "INR")}
                      </td>
                      <td className="text-center">
                        ₹
                        {CurrencyConverter.toCurrency(
                          item.discount || 0,
                          "INR",
                        )}
                      </td>
                      <td className="text-center">
                        ₹
                        {CurrencyConverter.toCurrency(
                          item.soldprice || 0,
                          "INR",
                        )}
                      </td>
                      <td className="w-120">
                        {item.imode === "SERVICE" ||
                        item.imode === "RECHARGE" ? (
                          <span className="text-center d-block">
                            {item.quantity} {item?.unitConfig?.primaryUnitCode}{" "}
                            {/* {item.unit && <small>/ {item.unit}</small>} */}
                          </span>
                        ) : (
                          // <div className="input-group">
                          //   <input
                          //     type="text"
                          //     value={item.quantity}
                          //     onFocus={(e) => {
                          //       e.stopPropagation();
                          //       handleQuantity(item, index);
                          //     }}
                          //     className="form-control text-center w-140"
                          //     min="1"
                          //   />

                          //   {item?.unit && (
                          //     <span
                          //       className="input-group-text text-muted"
                          //       style={{
                          //         fontSize: "11px",
                          //         padding: "0 6px",
                          //       }}
                          //     >
                          //       {item?.unit || "Units"}
                          //     </span>
                          //   )}
                          // </div>

                          <div className="text-center">
                            {item.quantity} {item?.unit}{" "}
                          </div>
                        )}
                      </td>
                      <td className="text-center">
                        ₹
                        {CurrencyConverter.toCurrency(
                          item.lineGrandTotal || 0,
                          "INR",
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="modal-footer d-block">
              <button
                className="btn shadow-none btn-outline-secondary text-left"
                onClick={onClose}
              >
                <XIcon iClass={"fs-15"}/> Cancel
              </button>

              <button
                className="btn btn-primary text-right"
                onClick={() => {
                  const items = data.saleitems
                    .filter((_, i) => selectedItems.includes(i))
                    .map((item) => ({
                      ...item,
                      fromSale: true,
                      saleId: data._id,
                      saleNo: data.saleno,
                    }));

                  onAdd(data, items);
                  onClose();
                }}
              >
                <CheckIcon/> Selected ({selectedItems.length}
                )
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default AddSaleProductProforma;
